import { useState, useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';
import ThemeMaker from "../../components/thememaker";
import { useParams, useHistory } from "react-router-dom";
import { registerSeller } from "../../store/features/seller/sellerSlice";
import { useSelector, useDispatch } from "react-redux";
import { config } from "../../utils/config";
import { toast } from "react-toastify";
import axios from "axios";
import "../../index.css"
import { Multiselect } from "multiselect-react-dropdown"
import brandStyles from "../Brand/Brand.module.css";
import styles from "./AddSeller.module.css";
import "../../components/mcrbTableTheme.css";
const { apiEndpoint, baseNodeapiUrl } = config

// Field-format validators for email / phone number inputs
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[6-9]\d{9}$/; // 10-digit Indian mobile number
const EMAIL_ERROR_MSG = "Please enter a valid email address !";
const PHONE_ERROR_MSG = "Please enter a valid 10-digit phone number !";


interface ICustomer {
    id: any;

}

const AddSeller = () => {
    const dispatch = useDispatch<any>();
    const _sellerData = useSelector((state: any) => state.sellerReducer);
    // console.log("_sellerData", _sellerData);

    let params: ICustomer = useParams();
    const history = useHistory();

    const [isgstValid, setisgstValid] = useState(true)
    const [ispanValid, setispanValid] = useState(true)
    const [isPanPresent, setispanPresent] = useState(false)
    const rawData = {
        name: '',
        email: '',
        company_name: '',
        contact_no: '',
        // provider_id: '',
        gst_no: '',
        pan_no: '',
        pan_name: '',
        pan_image: '',
        logo: '',
        address_proof: '',
        address_proof_image: '',
        gst_registered_address: "",
        // seller_commision: "",
        seller_id: 0,
        role_id: 2,
        status: 1,
        trade_license_number: "",
        personal_address: "",
        short_description: "",
        description: ""
    }
    const rawErrorData = {
        name: false,
        email: false,
        company_name: false,
        contact_no: false,
        // provider_id: false,
        gst_no: false,
        pan_no: false,
        pan_name: false,
        pan_image: false,
        address_proof: false,
        address_proof_image: false,
        gst_registered_address: false,
        logo: false,
        short_description: false,
        description: false
        // seller_commision: false,
    }
    const [sellerData, setSellerData]: any = useState(rawData);
    const [sellerDataError, setSellerDataError]: any = useState(rawErrorData);


    const inputHandler = (e: any) => {
        const { name, value } = e.target;
        // Phone field: keep digits only, cap at 10
        const newValue = name === "contact_no" ? value.replace(/\D/g, "").slice(0, 10) : value;
        setSellerData({ ...sellerData, [name]: newValue });
    }
    const errorHandler = (e: any) => {
        console.log(e.target.name)
        const gstregex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        var panregex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;

        if (e.target.value !== "") {
            if (e.target.name === "gst_no") {
                if (gstregex.test(e.target.value)) {
                    setisgstValid(true);
                } else {
                    setisgstValid(false);
                }
            }

            if (e.target.name === "pan_no") {
                if (panregex.test(e.target.value)) {
                    setispanValid(true);
                } else {
                    setispanValid(false);
                }
            }
        }


        const { name, value } = e.target;
        if (!value) {
            setSellerDataError({ ...sellerDataError, [name]: true });
        } else if (name === "email" && !EMAIL_REGEX.test(value.trim())) {
            setSellerDataError({ ...sellerDataError, [name]: EMAIL_ERROR_MSG });
        } else if (name === "contact_no" && !PHONE_REGEX.test(value.trim())) {
            setSellerDataError({ ...sellerDataError, [name]: PHONE_ERROR_MSG });
        } else {
            setSellerDataError({ ...sellerDataError, [name]: "valid" });
        }
    }

    // console.log("isGSTValid--->", isgstValid)
    const newUserCreatehandler = async () => {
        // console.log("sellerData => ", sellerData);
        // console.log("sellerDataError => ", sellerDataError);
        const { name,
            email,
            company_name,
            contact_no,
            // provider_id,
            gst_no,
            pan_no,
            pan_name,
            pan_image,
            address_proof,
            address_proof_image,
            gst_registered_address,
            // seller_commision,
            seller_id,
            short_description, description,
            role_id,
            status } = sellerData;
        if (email && !EMAIL_REGEX.test(String(email).trim())) {
            toast.error(EMAIL_ERROR_MSG, { position: "top-right", autoClose: 5000 });
            setSellerDataError({ ...sellerDataError, email: EMAIL_ERROR_MSG });
            return;
        }
        if (contact_no && !PHONE_REGEX.test(String(contact_no).trim())) {
            toast.error(PHONE_ERROR_MSG, { position: "top-right", autoClose: 5000 });
            setSellerDataError({ ...sellerDataError, contact_no: PHONE_ERROR_MSG });
            return;
        }
        if (name && email && company_name && contact_no && seller_id === 0 && short_description && description && pan_no) {
            const result = await dispatch(registerSeller(sellerData));
            if (result?.payload === true) {
                history.push("/sellerlist");
            }
        } else {
            toast.error("Please fill all the fields !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }
    const updateUserHandler = async () => {

    }


    const ImageHandler = async (e: any) => {
        const files = e.target.files;


        if (!files || files.length === 0) {
            alert("Please select file(s) first!");
            return;
        }

        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]); // Use the same key 'files'
        }

        try {
            const { data } = await axios.post(
                `${baseNodeapiUrl}/upload`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                        // Let browser set Content-Type
                    }
                }
            );

            if (data?.success) {
                toast.success(data.message || "Upload successful!");
                console.log("Uploaded URLs:", data.urls);
                // let { Location } = await s3.upload(params).promise();
                return data.urls[0];


            } else {
                toast.error("Upload failed!");
            }

        } catch (err) {
            console.error("Upload failed:", err);
            alert("Upload failed!");
        }
    };


    const setImage = async (e: any) => {
        const image: any = await ImageHandler(e);
        // console.log("Image----", image);
        setSellerData({ ...sellerData, [e.target.name]: image });
    }

    async function panvalidator() {
        // console.log(isgstValid, sellerData.gst_no)
        try {
            if (isgstValid && sellerData.gst_no !== "") {
                let GST = (sellerData.gst_no)
                // console.log(`https://gst-return-status.p.rapidapi.com/free/gstin/${GST}`)
                const { data } = await axios({
                    method: "GET",
                    url: `https://gst-return-status.p.rapidapi.com/free/gstin/${GST}`,
                    headers: {
                        "X-RapidAPI-Key": "94523712ebmsh4d5f7883670d8b8p15ff44jsnec2992be994a",
                        "X-RapidAPI-Host": "gst-return-status.p.rapidapi.com"
                    }
                })

                if (data.success === true) {
                    setisgstValid(true)
                    if (data?.data?.pan) {
                        setispanPresent(true)
                        setSellerData({ ...sellerData, pan_no: data?.data?.pan })
                    }

                } else {
                    setisgstValid(false)
                }
            }
        } catch (err) {
            console.log("GST Validation Error", err)
        }
    }
    useEffect(() => {

    }, []);
    const [selectedDomain, setselectedDomain]: any = useState();

    const [domain, setDomain] = useState([
        { cday: "Grocery", id: "ONDC:RET10" }, { cday: "Fashion ", id: "ONDC:RET12" }, { cday: "BPC", id: "ONDC:RET13" }, { cday: "Electronics", id: "ONDC:RET14" }, { cday: "Appliances", id: "ONDC:RET15" }, { cday: "Home & Kithcen", id: "ONDC:RET16" }, { cday: "Health & Wellness", id: "ONDC:RET18" }, { cday: "F&B", id: "ONDC:RET11" }
    ])
    return (
        <>
            <ThemeMaker>
                <div className={`${styles.pageWrap} mcrb-page`}>
                    <div className={`${brandStyles.cardOuter} mcrb-card`}>
                        <div className={brandStyles.headerBar}>
                            <span className={brandStyles.title}>Register Seller</span>
                        </div>

                        <div className={`${brandStyles.bodyArea} ${styles.formBody}`}>
                            <p className={styles.sectionTitle}>Basic Details</p>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>
                                            Name<span className={brandStyles.required}>*</span>
                                            {sellerDataError?.name !== "valid" && sellerDataError?.name !== false ? (
                                                <span className={brandStyles.errorText}> This field is required !</span>
                                            ) : null}
                                        </label>
                                        <input type="text" className={brandStyles.input} name="name" placeholder="Enter name"
                                            value={sellerData.name}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Company name<span className={brandStyles.required}>*</span>
                                            {sellerDataError?.company_name !== "valid" && sellerDataError?.company_name !== false ? (
                                                <span className={brandStyles.errorText}> This field is required !</span>
                                            ) : null}
                                        </label>
                                        <input type="text" className={brandStyles.input} name="company_name" placeholder="Enter company name"
                                            value={sellerData.company_name}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Short Description<span className={brandStyles.required}>*</span>
                                            {sellerDataError?.short_description !== "valid" && sellerDataError?.short_description !== false ? (
                                                <span className={brandStyles.errorText}> This field is required !</span>
                                            ) : null}
                                        </label>
                                        <input type="text" className={brandStyles.input} name="short_description" placeholder="Enter short description"
                                            value={sellerData.short_description}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Long Description<span className={brandStyles.required}>*</span>
                                            {sellerDataError?.description !== "valid" && sellerDataError?.description !== false ? (
                                                <span className={brandStyles.errorText}> This field is required !</span>
                                            ) : null}
                                        </label>
                                        <input type="text" className={brandStyles.input} name="description" placeholder="Enter long description"
                                            value={sellerData.description}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Email address<span className={brandStyles.required}>*</span>
                                            {sellerDataError?.email !== "valid" && sellerDataError?.email !== false ? (
                                                <span className={brandStyles.errorInline}>{sellerDataError?.email === true ? "This field is required !" : sellerDataError?.email}</span>
                                            ) : null}
                                        </label>
                                        <input type="text" name="email" className={brandStyles.input} placeholder="Enter email"
                                            value={sellerData.email}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Contact No.<span className={brandStyles.required}>*</span>
                                            {sellerDataError?.contact_no !== "valid" && sellerDataError?.contact_no !== false ? (
                                                <span className={brandStyles.errorInline}>{sellerDataError?.contact_no === true ? "This field is required !" : sellerDataError?.contact_no}</span>
                                            ) : null}
                                        </label>
                                        <input type="text" inputMode="numeric" maxLength={10} name="contact_no" className={brandStyles.input} placeholder="Enter contact number"
                                            value={sellerData.contact_no}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Logo</label>
                                        <input type="file" name="logo" className={brandStyles.fileInput}
                                            onChange={(e) => setImage(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <p className={styles.sectionTitle}>Identity &amp; Documents</p>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>PAN Number<span className={brandStyles.required}>*</span>
                                            {sellerDataError?.pan_no !== "valid" && sellerDataError?.pan_no !== false ? (
                                                <span className={brandStyles.errorText}> This field is required !</span>
                                            ) : null}
                                            {ispanValid ? null : <span className={brandStyles.errorText}> The PAN you have entered is invalid !</span>}
                                        </label>
                                        <input type="text" className={brandStyles.input} name="pan_no" placeholder="Enter PAN number"
                                            value={sellerData.pan_no}
                                            onChange={(e) => inputHandler(e)}
                                            maxLength={10}
                                            readOnly={isPanPresent ? true : false}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Name as per PAN</label>
                                        <input type="text" className={brandStyles.input} name="pan_name" placeholder="Name as per pan"
                                            value={sellerData.pan_name}
                                            onChange={(e) => inputHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>PAN image</label>
                                        <input type="file" name="pan_image" className={brandStyles.fileInput}
                                            onChange={(e) => setImage(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Address Proof</label>
                                        <select name="address_proof" id="" className={brandStyles.input}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => errorHandler(e)}
                                        >
                                            <option value="">Select address proof</option>
                                            <option value="Aadhar card">Aadhar card</option>
                                            <option value="Ration card">Ration card</option>
                                            <option value="Telephone bill">Telephone bill</option>
                                            <option value="Bank Passbook">Bank Passbook</option>
                                            <option value="Electricity bill">Electricity bill</option>
                                            <option value="Lease or license agreement">Lease or license agreement</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Address Proof image</label>
                                        <input type="file" name="address_proof_image" className={brandStyles.fileInput}
                                            onChange={(e) => setImage(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>GST</label>
                                        <input type="text" className={brandStyles.input} name="gst_no" placeholder="Enter GST number"
                                            value={sellerData.gst_no}
                                            onChange={(e) => inputHandler(e)}
                                            onBlur={(e) => { errorHandler(e); panvalidator() }}
                                            onFocus={() => setisgstValid(true)}
                                            maxLength={15}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>GST image <span className={styles.hintText}>(coming soon)</span></label>
                                        <input type="file" name="gts_image" className={brandStyles.fileInput} disabled />
                                    </div>
                                </div>
                            </div>

                            <p className={styles.sectionTitle}>Address &amp; Registration</p>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>GST Registered Address</label>
                                        <input type="text" name="gst_registered_address" className={brandStyles.input} placeholder="Enter GST registered address"
                                            value={sellerData.gst_registered_address}
                                            onChange={(e) => inputHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Personal Address</label>
                                        <input type="text" name="personal_address" className={brandStyles.input} placeholder="Enter personal address"
                                            value={sellerData.personal_address}
                                            onChange={(e) => inputHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={brandStyles.field}>
                                        <label className={brandStyles.label}>Trade License Number</label>
                                        <input type="text" name="trade_license_number" className={brandStyles.input} placeholder="Enter trade license number"
                                            value={sellerData.trade_license_number}
                                            onChange={(e) => inputHandler(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className={`${brandStyles.field} ${styles.field}`}>
                                        <label className={brandStyles.label}>Product Domains<span className={brandStyles.required}>*</span></label>
                                        <Multiselect options={domain} selectedValues={selectedDomain} displayValue="cday" onSelect={(selectedList, selectedItem) => {
                                            let daySelected = selectedList.map((item: any) => item.id)
                                            let z = daySelected.toString()
                                            setselectedDomain(selectedList.map((item: any) => item));
                                            setSellerData({ ...sellerData, ondc_domain: z });
                                        }}
                                            onRemove={(selectedList, selectedItem) => {
                                                let daySelected = selectedList.map((item: any) => item.id);
                                                let z = daySelected.toString()
                                                setselectedDomain(selectedList.map((item: any) => item));
                                                setSellerData({ ...sellerData, ondc_domain: z });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={styles.submitRow}>
                                <button type="submit" className={brandStyles.saveBtn} style={{ width: "220px" }}
                                    onClick={newUserCreatehandler}>
                                    {_sellerData?.loading ? 'Saving...' : "Register seller"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ThemeMaker>
        </>
    )
}

export default AddSeller;